import React, { useState, useEffect } from "react";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import SimpleReactValidator from "simple-react-validator";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";
import API from "../api";
import Branch from "components/Branch/Branch";
import BranchesFilter from "components/Branch/BranchesFilter";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import NocBanner from "components/PublicPagesReusable/NocBanner";
import SkillAreas from "components/PublicPagesReusable/SkillAreas";
import Training from "assets/images/public-pages/green-chat.svg";
import ConsistentResult from "assets/images/public-pages/green-idea.svg";
import Materials from "assets/images/public-pages/green-screen.svg";
import LocalExpertise from "assets/images/public-pages/green-messages.svg";
import FlexibleOptions from "assets/images/public-pages/green-horse.svg";
import TickCircle from "/public/images/tick-circle.png";
import Success from "assets/images/public-pages/Success.svg";
import Globe from "assets/images/public-pages/green-globe.svg";
import ButtonComp from "components/PublicPagesReusable/ButtonComp";
import nepal from "assets/images/public-pages/nepal.svg";
import india from "assets/images/public-pages/india.svg";
import australia from "assets/images/public-pages/australia.svg";
import callIcon from "assets/images/public-pages/green-call.svg";
import CtaBanner from "components/PublicPagesReusable/CtaBanner";

const Branches = () => {
  const [submit, setSubmit] = useState(false);
  const [flag, setFlag] = useState(false);
  const [lockSubmit, setLockSubmit] = useState(false);
  const [branches, setBranches] = useState([]);
  const [activeTab, setActiveTab] = useState("all");

  const validator = new SimpleReactValidator();

  useEffect(() => {
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);

    // ReactPixel.init("197333187452630");
    // ReactPixel.pageView();
    getBranches();
  }, []);

  const getBranches = () => {
    API({
      url: "getAllBranches",
      method: "GET",
    }).then((res) => {
      if (res.status && res.status === 200) {
        setBranches(res.data.branches);
      }
    });
  };

  const branchSliderSettings = {
    dots: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 4000,
  };

  const CardsSlider = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    adaptiveHeight: true,
    autoplaySpeed: 5000,
      responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

    const heroWorkTitle = () => {
    return (
      <h1 className="FS48 fw-500 top-section-text text-center">
         Your Success <br/>
        <span className="fw-600 text-success">Our Global Reach</span>
        {/* <br /> */}
      </h1>
    );
  };

    const heroData = {
    badge: "10+ Locations Worldwide",
    title: heroWorkTitle,
    subtitle: "Expert coaching, proven methodology, and personalized support — delivered with the same <br/>excellence at every Language Academy location worldwide. ",
    profile: {
      image: "/images/web-new-images/new-content-slider/Varun-sir-hero.webp",
      stats: [
        { value: "10K+", label: "Students" },
        { value: "85%", label: "First-Attempt Success" },
        { value: "4.8★", label: "Google Rating" }
      ]
    },
    bottomStats: [
      { value: "Australia", highlight: '1 Branch', label: "Parramatta HQ", icon: australia,center:true},
      { value: "India", highlight: '9 Branches', label: "Punjab, Haryana, Rajasthan, Telangana", icon: india ,center:true},
      { value: "Nepal", highlight: '1 Branch', label: "Butwal Centre ", icon: nepal,center:true }
    ]
  };

   const skillAreaTitle2 = () => {
    return (
      <p className="top-section-text FS40FW600">
       One Standard,<br/> 
        <span className="text-success FS40FW600">Global Excellence</span>
        <br />
      </p>
    );
  };
   const styleCards = [
      {
        title: "Identical Training Quality",
        text: "Same proven methodologies and expert instruction",
        color: "#141414",
        img: Training,
        boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
        borderColor:'rgba(0, 0, 0, 0.05)'
      },
      {
        title: "Consistent Results",
        text: "95% success rate maintained across all locations",
        color: "#141414",
        img: ConsistentResult,
        boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
        borderColor:'rgba(0, 0, 0, 0.05)'
      },
      {
        title: "Updated Materials",
        text: "Real-time access to latest strategies and prediction files",
        color: "#141414",
        img: Materials,
        boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
        borderColor:'rgba(0, 0, 0, 0.05)'
      },
      {
        title: "Local Expertise",
        text: "Trainers who understand regional needs and challenges",
        color: "#141414",
        img: LocalExpertise,
        boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
        borderColor:'rgba(0, 0, 0, 0.05)'
      },
      {
        title: "Flexible Options",
        text: "Online support available even at physical locations",
        color: "#141414",
        img: FlexibleOptions,
        boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
        borderColor:'rgba(0, 0, 0, 0.05)'
      },
    ];

    const features = [
  {
    title: "Live Virtual Classrooms",
    description: "Expert-led sessions with real-time interaction",
  },
  {
    title: "AI-Powered Practice Platform",
    description: "Accessible from anywhere, any device",
  },
  {
    title: "Real-Time Feedback",
    description: "Instant scoring and personalized coaching",
  },
  {
    title: "Global Time Zone Coverage",
    description: "Classes scheduled across all major time zones",
  },
  {
    title: "Same Quality Guarantee",
    description: "Identical methodology and success rate as in-person classes",
  },
];

const supportFeatures = [
  {
    title: "Cultural Understanding",
    description: "Trainers who understand local student challenges",
  },
  {
    title: "Regional Immigration Knowledge",
    description: "Specific visa and pathway expertise",
  },
  {
    title: "Language Support",
    description: "Native language assistance where needed",
  },
  {
    title: "Community Connections",
    description: "Local success stories and networking",
  },
];

const provenRegions = [
  {
    title: "Australia",
    description: "95% success rate for English test prep",
  },
  {
    title: "India",
    description: "90% of students' achieve target scores within 6 weeks",
  },
  {
    title: "Nepal",
    description: "A leading provider for Australian migration test preparation",
  }
];

const enquiryCards = [
  {
    id: 1,
    className: "card2",
    title: "AUSTRALIA ENQUIRIES",
    flag: australia,
    details: [
      {
        label: "Phone",
        value: "+61 426 230 061",
        link: "tel:61426230061",
      },
      {
        label: "Email",
        value: "info@languageacademy.com.au",
        link: "mailto:info@languageacademy.com.au",
      },
      {
        label: "Address",
        value: "46 George Street, Parramatta NSW 2150",
      },
    ],
  },
  {
    id: 2,
    className: "card1",
    title: "INDIA ENQUIRIES",
    flag: india,
    details: [
      {
        label: "Phone",
        value: "+91 765 281 1911",
        link: "tel:917652811911",
      },
      {
        label: "Email",
        value: "info@languageacademy.com.au",
        link: "mailto:info@languageacademy.com.au",
      },
      {
        label: "Regional Contact",
        value: "Jalandhar Headquarters",
      },
    ],
  },
  {
    id: 3,
    className: "card4",
    title: "NEPAL ENQUIRIES",
    flag: nepal,
    details: [
      {
        label: "Phone",
        value: "+977 71 591 305",
        link: "tel:97771591305",
      },
      {
        label: "Email",
        value: "info@languageacademy.com.au",
        link: "mailto:info@languageacademy.com.au",
      },
      {
        label: "Regional Contact",
        value: "Butwal Centre",
      },
    ],
  },
  {
    id: 4,
    className: "card3",
    title: "GLOBAL ONLINE SUPPORT",
    flag: callIcon,
    details: [
      {
        label: "Phone",
        value: "+61 455 566 654",
        link: "tel:61455566654",
      },
      {
        label: "Available",
        value: "24/7 across all time zones",
      },
    ],
  },
];
    const openPopup = () => {
    const modal = new window.bootstrap.Modal(
      document.getElementById("staticBackdrop")
    );
    modal.show();
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>Our Branches | Branches for PTE & NAATI CCL Test Preparation</title>
        <meta name="description" content="10+ branches worldwide LA Language Academy delivering expert PTE and NAATI CCL coaching. Your success, proven results and support at every location." />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`https://www.languageacademy.com.au/branches`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@languageacademy" />
        <meta name="twitter:title" content="Our Branches | Branches for PTE & NAATI CCL Test Preparation" />
        <meta name="twitter:description" content="10+ branches worldwide LA Language Academy delivering expert PTE and NAATI CCL coaching. Your success, proven results and support at every location." />
        <meta name="twitter:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
        <meta name="twitter:image:alt" content="LA Language Academy Logo" />
        <meta property="og:url" content={`https://www.languageacademy.com.au/branches`} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Our Branches | Branches for PTE & NAATI CCL Test Preparation" />
        <meta property="og:description" content="10+ branches worldwide LA Language Academy delivering expert PTE and NAATI CCL coaching. Your success, proven results and support at every location." />
        <meta property="og:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
        <meta property="og:image:alt" content="LA Language Academy Logo" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
      </Helmet>
        <div className="new-design">
        <Header />
        <NocBanner data={heroData} />
        <div className="off-white global-excellence" style={{paddingTop:"11%"}}>
          <SkillAreas
            className={"skill-section off-white"}
            background={"#F9F9F9"}
            color={"black"}
            skillAreaTitle={skillAreaTitle2}
            lifestyleCards={styleCards}
            btnText={"Book Your Free Consultation"}
            skillSubtitle={
              "No matter which Language Academy branch you visit, you'll receive:"
            }
            img="/images/web-new-images/new-dark-arrow.svg"
            sliders={4.5}
            cardClass={"bg-white"}
            btnLink={openPopup}
            skillBottomtitle={"Experience world-class coaching wherever you are."}
            italic={true}
          />
        </div>
          <section className="branchesOuter p-80">
            <div className="custom-container">
              <div className="row">
              <p className="top-section-text FS40FW600 d-flex justify-content-center align-items-center flex-column mb-0">
                Find Your<br />
                <span className="text-success FS40FW600">Nearest Location</span>
                <br />
              </p>
              <BranchesFilter
                tabs={[
                  { id: "all", label: "All", count: branches.filter(b => b.branch_detail).length },
                  { id: "australia", label: "Australia", count: branches.filter(b => b.branch_detail?.country === "Australia").length },
                  { id: "india", label: "India", count: branches.filter(b => b.branch_detail?.country === "India").length },
                  { id: "nepal", label: "Nepal", count: branches.filter(b => b.branch_detail?.country === "Nepal").length },
                ]}
                onTabChange={(tab) => setActiveTab(tab.id)}
              />
                {/* Desktop */}
                <div className="branches-second-row">
                  {branches
                    .filter((b) => activeTab === "all" || b.branch_detail?.country?.toLowerCase() === activeTab)
                    .map((branch) => (
                      <Branch branch={branch.branch_detail} key={branch.id} />
                    ))}
                </div>
                {/* Mobile */}
                {/* <div className="d-block d-lg-none slider-dot-arrow">
                  <Slider {...branchSliderSettings} className="branches-second-row">
                    {branches
                      .filter((b) => activeTab === "all" || b.branch_detail?.country?.toLowerCase() === activeTab)
                      .map((branch) => (
                        <Branch branch={branch.branch_detail} key={branch.id} />
                      ))}
                  </Slider>
                </div> */}
              </div>
            </div>
          </section>

          <div className="master-aspect-section branch-global-reach branch-online-support">
            <div className="custom-container">
              <div className="row">

                <div className="master-cards">
                  <div className="master-card border-0">
                    <h1 className="FS48 fw-500 top-section-text mb-0">
                    Can't Visit in Person?<br/>
                    <span className="fw-600 text-success">We're Online 24/7</span>
                    </h1>
                    <p className="FS16FW500">For students' worldwide who can't access our physical locations — get the same world-class training from anywhere, at any time zone.</p>
                  <div className="mapOuter d-flex align-items-center gap-3 gray-border p-4">
             <div className="country-code-box">
              AU
             </div>
             <div>
               <p className="text-gray-pricing FS16FW500 fw-600 mb-0">AUSTRALIA-BASED SUPPORT</p>
               <h3 className="mb-0 top-section-text FS24FW500 fw-600">+61 455 566 654</h3>
             </div>
            </div>
             <div className="mapOuter d-flex align-items-center gap-3 gray-border p-4">
             <div className="country-code-box">
              IN
             </div>
             <div>
               <p className="text-gray-pricing FS16FW500 fw-600 mb-0">INDIA-BASED SUPPORT</p>
               <h3 className="mb-0 top-section-text FS24FW500 fw-600">+91 765 281 1912</h3>
             </div>
            </div>
                  </div>
                  <div className="master-card card3 border-0">
                    <div className="master-card card3 border-0">
                    {features.map((item, index) => (
                   <div  key={index} className="mapOuter d-flex gap-3">
                   <img src={TickCircle} alt="Check" className="list-data" style={{width:"20px",height:"20px",marginTop:"6px"}}/>
                  <div>
                  <h3 className="mb-1 top-section-text FS24FW500 fw-600">{item?.title}</h3>
                  <p className="text-gray-pricing FS16FW500 mb-0">{item?.description}</p>
                 </div>
                 </div>
                    ))}
                  </div>
                  </div>
                </div>             
              </div>
            </div>
          </div>
          <div className="master-aspect-section branch-global-reach branch-why-location">
            <div className="custom-container">
              <div className="row">
                  <h1 className="FS48 fw-500 top-section-text text-center mb-0">
                    Why <span className="fw-600 text-success">Location</span> Matters
                    </h1>   

                <div className="master-cards my-0">
                  <div className="master-card">
                     <img src={Globe} alt="Success" style={{width:"52px",height:"52px"}}/>

                    <h2 className="FS24FW500 fw-700 plus-sans mb-0">Local Expertise, Global Success</h2>
                    <p className="FS16FW500 fw-600 plus-sans text-gray-pricing mb-0">Each Branch Offers:</p>
                    <div>
                         {supportFeatures.map((item, index) => (
                   <div  key={index} className="mapOuter d-flex gap-3 mb-3">
                   <img src={TickCircle} alt="Check" className="list-data" style={{width:"20px",height:"20px",marginTop:"5px"}}/>
                  <div>
                  <h3 className="mb-1 top-section-text FS18FW400 fw-700 plus-sans">{item?.title}</h3>
                  <p className="text-gray-pricing FS16FW500 fw-600 plus-sans mb-0">{item?.description}</p>
                 </div>
                 </div>
                    ))}
                    </div>
                  </div>
                  <div className="master-card card3">
                     <img src={Success} alt="Success" style={{width:"52px",height:"52px"}}/>

                    <h2 className="FS24FW500 fw-700 plus-sans mb-0">Proven Regional Success</h2>
                    <div>
                    {provenRegions.map((item, index) => (
                   <div  key={index} className="mapOuter d-flex gap-3 mb-3">
                   <img src={TickCircle} alt="Check" className="list-data" style={{width:"20px",height:"20px",marginTop:"5px"}}/>
                  <div>
                  <h3 className="mb-1 top-section-text FS18FW400 fw-700 plus-sans">{item?.title}</h3>
                  <p className="text-gray-pricing FS16FW500 fw-600 plus-sans mb-0">{item?.description}</p>
                 </div>
                 </div>
                    ))}
                      <p className="FS16FW500 fw-600 plus-sans text-gray-pricing mb-0">Your location shouldn't limit your success, and with us, it won't.</p>
                    </div>
                  </div>
                </div> 
              </div>
            </div>
          </div>
           <div className="why-choosing-section poc-why-choosing branch-our-locations pb-0">
              <div className="custom-container">
                <div className="row">
                  <div className="d-flex align-items-center flex-column flex-lg-row gap-2 justify-content-between">
                      <h1 className="FS40FW600 top-section-text mb-0 text-center text-lg-start">
                    Contact <span className="fw-600 text-success">Our <br/>Locations</span>
                    </h1> 
                    <ButtonComp link={openPopup} btnText={"Find Your Success Centre Today"}/>
                  </div>
              <div className="feature-cards four-cards country-name">
                {enquiryCards.map((card, index) => (
                  <div
                    key={card.id}
                    className={`feature-card ${card.className}`}
                  >
                    <div className="d-flex flex-column gap-4">
                       <div>
                        <img src={card.flag} alt={card.title} className="w-44"/>
                       </div>
                      <h3 className="FS24FW500 fw-700 plus-sans">
                        {card.title}
                      </h3>
                      </div>

                    <ul>
                      {card.details.map((item, i) => (
                        <li key={i}>
                          <p className="FS14FW600 fw-600 plus-sans text-gray-pricing">{item.label}</p>

                          <p className="FS16FW500 plus-sans fw-700">
                            {item.link ? (
                              <a className="FS16FW500 plus-sans fw-700" href={item.link}>{item.value}</a>
                            ) : (
                              item.value
                            )}
                          </p>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
                  {/* Mobile HTML */}
                  {/* <div className="slider-dot-arrow d-block d-md-none mobile-slider">
                    <Slider {...CardsSlider} className="feature-cards four-cards country-name-slider"> */}
                      {/* <div className="feature-card card2">                        
                      <h3><img
                          src="/images/web-new-images/flages/au-flag.png"
                          alt="Register Now"
                        /> AUSTRALIA ENQUIRIES</h3>
                      <ul>
                         <li>
                          <strong>Phone</strong>
                          <p><a href="tel:61426230061">+61 426 230 061</a></p>
                        </li>
                        <li>
                          <strong>Email</strong>
                          <p><a href="mailto:info@languageacademy.com.au">info@languageacademy.com.au</a></p>
                        </li>
                        <li>
                          <strong>Address</strong>
                          <p>46 George Street, Parramatta NSW 2150</p>
                        </li>
                      </ul>
                      </div>
                      <div className="feature-card card1">
                        <h3><img
                            src="/images/web-new-images/flages/in-flag.png"
                            alt="Register Now"
                          />  INDIA ENQUIRIES</h3>
                        <ul>
                          <li>
                            <strong>Phone</strong>
                            <p><a href="tel:917652811911">+91 765 281 1911</a></p>
                          </li>
                          <li>
                            <strong>Email</strong>
                            <p><a href="mailto:info@languageacademy.com.au">info@languageacademy.com.au</a></p>
                          </li>
                          <li>
                            <strong>Regional Contact</strong>
                            <p>Jalandhar Headquarters</p>
                          </li>                         
                        </ul>
                      </div>
                      <div className="feature-card card4">
                        <h3><img
                            src="/images/web-new-images/flages/ne-flag.png"
                            alt="Register Now"
                          /> NEPAL ENQUIRIES</h3>
                        <ul>
                          <li>
                            <strong>Phone</strong>
                            <p><a href="tel:97771591305">+977 71 591 305</a></p>
                          </li>
                          <li>
                            <strong>Email</strong>
                            <p><a href="mailto:info@languageacademy.com.au">info@languageacademy.com.au</a></p>
                          </li>
                          <li>
                            <strong>Regional Contact</strong>
                            <p>Butwal Centre</p>
                          </li>                         
                        </ul>
                      </div>
                      <div className="feature-card card3">
                        <div className="rounded-circle">
                          <div className="img-wrapper">
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.0497 6.81641C15.0264 7.00697 15.924 7.48466 16.6277 8.18834C17.3314 8.89202 17.8091 9.78967 17.9997 10.7664M14.0497 2.81641C16.0789 3.04184 17.9713 3.95058 19.4159 5.39341C20.8606 6.83625 21.7717 8.72742 21.9997 10.7564M10.2266 14.6795C9.02506 13.4779 8.07627 12.1193 7.38028 10.6696C7.32041 10.5449 7.29048 10.4826 7.26748 10.4037C7.18576 10.1234 7.24446 9.7791 7.41447 9.54167C7.46231 9.47486 7.51947 9.4177 7.63378 9.30339C7.98338 8.95378 8.15819 8.77898 8.27247 8.6032C8.70347 7.94031 8.70347 7.08573 8.27247 6.42284C8.15819 6.24706 7.98338 6.07226 7.63378 5.72265L7.43891 5.52778C6.90747 4.99634 6.64174 4.73062 6.35636 4.58627C5.7888 4.2992 5.11854 4.2992 4.55098 4.58627C4.2656 4.73062 3.99987 4.99634 3.46843 5.52778L3.3108 5.68542C2.78117 6.21504 2.51636 6.47985 2.31411 6.83988C2.08969 7.23939 1.92833 7.85988 1.9297 8.3181C1.93092 8.73105 2.01103 9.01327 2.17124 9.57772C3.03221 12.6111 4.65668 15.4735 7.04466 17.8615C9.43264 20.2494 12.295 21.8739 15.3284 22.7349C15.8928 22.8951 16.1751 22.9752 16.588 22.9764C17.0462 22.9778 17.6667 22.8164 18.0662 22.592C18.4263 22.3898 18.6911 22.1249 19.2207 21.5953L19.3783 21.4377C19.9098 20.9062 20.1755 20.6405 20.3198 20.3551C20.6069 19.7876 20.6069 19.1173 20.3198 18.5498C20.1755 18.2644 19.9098 17.9986 19.3783 17.4672L19.1835 17.2723C18.8339 16.9227 18.6591 16.7479 18.4833 16.6336C17.8204 16.2026 16.9658 16.2026 16.3029 16.6336C16.1271 16.7479 15.9523 16.9227 15.6027 17.2723C15.4884 17.3867 15.4313 17.4438 15.3644 17.4916C15.127 17.6617 14.7828 17.7204 14.5024 17.6386C14.4235 17.6156 14.3612 17.5857 14.2365 17.5258C12.7869 16.8298 11.4282 15.8811 10.2266 14.6795Z" stroke="#0286FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </div>
                        <h3>GLOBAL ONLINE SUPPORT</h3>
                        </div>
                        <ul>
                          <li>
                            <strong>Phone</strong>
                            <p><a href="tel:61455566654">+61 455 566 654</a></p>
                          </li>
                          <li>
                            <strong>Available</strong>
                            <p>24/7 across all time zones</p>
                          </li>                         
                        </ul>
                      </div> */}
                       {/* {enquiryCards.map((card, index) => (
                  <div
                    key={card.id}
                    className={`feature-card ${card.className}`}
                  >
                    <div className="d-flex flex-column gap-4">
                       <img src={card.flag} alt={card.title} className="w-44"/>
                      <h3 className="FS24FW500 fw-700 plus-sans">
                        {card.title}
                      </h3>
                      </div>

                    <ul>
                      {card.details.map((item, i) => (
                        <li key={i}>
                          <p className="FS14FW600 fw-600 plus-sans text-gray-pricing">{item.label}</p>

                          <p className="FS16FW500 plus-sans fw-700">
                            {item.link ? (
                              <a className="FS16FW500 plus-sans fw-700" href={item.link}>{item.value}</a>
                            ) : (
                              item.value
                            )}
                          </p>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
                    </Slider>
                  </div> */}
                </div>
                <div className="d-flex align-items-center justify-content-center mt-3">
                  <div className="col-lg-7">
                    <p className="quote-para FS18FW400 fw-700 text-center">
                      <em>Your journey to success starts with choosing the right location. Every Language <br/> Academy branch is the right choice.</em>
                    </p>
                  </div>
                </div>
              </div>
          </div>
          <div className="custom-container">
          <div style={{ padding: "40px 0 30px 0" }}>
          <CtaBanner
          title="Ready to Achieve Your"
          highlight="Target Score?"
          buttonText="Book Free Consultation"
          onClick={openPopup}
          rightImage="/images/web-new-images/HomePageImage/CTA-Image.webp"
          btnText="See Our Programs"
          subTitle={
          "Join the thousands of students' who've transformed their futures with Language Academy. Don't let another failed attempt delay your dreams."
            }
          />
          </div>
          </div>
      <Footer />
          </div>
    </React.Fragment>
  );
};

export default Branches;